import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Container } from 'react-bootstrap'
import "./styles/saleOrders-styles.scss"
import SaleOrdersTableTopBar from './includes/SaleOrdersTable/SaleOrdersTableTopBar'
import SaleOrdersTable from './includes/SaleOrdersTable/SaleOrdersTable'
import Pagination from 'components/CommonComponents/Pagination'
import { debounce } from 'utlis/helpers/Common/CommonHelperFunctions'
import {
    CONFIRMATION_BEFORE_DELETING_BRAND,
} from 'utlis/AppMessages/AppMessages'
import { getOders, getOrderStatusList } from 'utlis/Apis/SaleOrder_API'
import { ERROR_WHILE_FETCHING_BRANDS } from 'utlis/AppMessages/AppMessages'
import { toast } from 'react-toastify'
import { ERROR_WHILE__NAME } from 'utlis/AppMessages/AppMessages'
import { UNKNOWN_ERROR_OCCURED } from 'utlis/AppMessages/AppMessages'
import useQueryHook from 'utlis/CustomHooks/useQueryHook'


function SaleOrders(props) {
    // props
    const { commonToken } = props

    // states
    const loadingCount = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
    const [saleOrders, setSaleOrders] = useState([])
    const [loading, setLoading] = useState(false)
    const [allCheckboxSelected, setAllCheckboxesSelected] = useState(false)
    const [column__saleOrderNumber, setColumn__saleOrderNumber] = useState(true)
    const [column__orderDate, setColumn__orderDate] = useState(true)
    const [column__customers, setColumn__customers] = useState(true)
    const [column__subTotal, setColumn__subTotal] = useState(true)
    const [column__promoDiscount, setColumn__promoDiscount] = useState(true)
    const [column__shipping, setColumn__shipping] = useState(true)
    const [column__total, setColumn__total] = useState(true)
    const [column__fullFillmentStatus, setColumn__fullFillmentStatus] = useState(true)
    const [column__paymentStatus, setColumn__paymentStatus] = useState(true)
    const [column__paymentMethod, setColumn__paymentMethod] = useState(true)
    const [paginationLinks, setPaginationLinks] = useState([])


    const [searchQuery, setSearchQuery] = useState("")

    const [orderStatusList, setOrderStatusList] = useState([])

    let queryy = useQueryHook();

    useEffect(() => {
        let page = queryy.get('page')
        let keyword = queryy.get('keyword')

        let query = `${(keyword) ? "keyword=" + keyword + "&" : ""}${page ? "page=" + page : ""}`
        setLoading(true)
        getOders(props.currentUser.userToken, query).then(res => {
            setLoading(false)
            const resData = res.data
            // scroll the page to the top
            window.scrollTo(0, 0)
            if (resData && resData.success) {
                setPaginationLinks(resData.links)
                setSaleOrders(resData.data)
            }
            if (resData && resData.error) {
                console.log(ERROR_WHILE_FETCHING_BRANDS, resData)
                toast.dismiss();
                toast.error(ERROR_WHILE_FETCHING_BRANDS, {
                    autoClose: 3000,
                    onClose: () => {
                        // disabling loading
                        setLoading(false)
                    }
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} get saleOrders `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                    setLoading(false)
                }
            })
        })
    }, [props])

    // gettig order status list
    useEffect(() => {
        getOrderStatusList(commonToken).then(res => {
            const resData = res.data

            // if request is success
            if (resData?.success) {
                setOrderStatusList(resData?.data) // setting status data
            }

            // if request is error
            if (resData?.error) {
                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(resData?.message || UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500
                });
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getOrderStatusList and getOrderPaymentStatusList`, err.message);

            // dismissing all the previous toasts first
            toast.dismiss();

            // showing the error message
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500
            });
        })
    }, [commonToken])

    const handleSelectAllChange = (ev) => {
        const checkboxes = document.getElementsByClassName('all-checkboxes-selector-checkbox')
        setAllCheckboxesSelected(!allCheckboxSelected)
        setTimeout(() => {
            if (ev.target.checked) {
                checkboxes.length && Array.from(checkboxes).forEach(checkbox => {
                    checkbox.checked = true
                });
            } else {
                checkboxes.length && Array.from(checkboxes).forEach(checkbox => {
                    checkbox.checked = false
                });
            }
        }, 50);

    };

    // deleting
    const handleDelete = (ev) => {
        ev.preventDefault()
        var confirmation = window.confirm(CONFIRMATION_BEFORE_DELETING_BRAND)

        if (confirmation) {
            // deleteBrand(props.currentUser.userToken, brandId).then(res => {
            //     setSectionLoadingVisible(false)
            //     const deletedData = res.data
            //     if (deletedData.success) {
            //         const filteredList = saleOrders.filter(item => item.manufacturer_id !== brandId)
            //         setBrands(filteredList)
            //         // dismissing all the previous toasts first
            //         toast.dismiss();
            //         toast.success(BRAND_DELETED_SUCCESSFULLY, {
            //             autoClose: 2500,
            //             onClose: () => {
            //             }
            //         })
            //     }
            //     if (deletedData.error) {
            //         console.log(ERROR_WHILE_DELETING_BRAND, res)
            //         toast.dismiss();
            //         toast.error(ERROR_WHILE_DELETING_BRAND, {
            //             autoClose: 2500,
            //         })
            //     }
            // }).catch(err => {
            //     console.log(`${ERROR_WHILE__NAME} deleteBrand `, err.message)
            //     toast.dismiss();
            //     toast.error(UNKNOWN_ERROR_OCCURED, {
            //         autoClose: 2500,
            //         onClose: () => {
            //             setSectionLoadingVisible(false)
            //         }
            //     })
            // })
        }
    }
    const handleSearchChange = debounce(ev => {
        let searchQueryValue = ev.target.value
        if (searchQueryValue && searchQueryValue.length) {
            setSearchQuery(searchQueryValue)
            props.history.push(`/my-sales/sale-orders?keyword=${searchQueryValue}&page=1`)
        }

        if (!searchQueryValue) {
            setSearchQuery("")
            props.history.push(`/my-sales/sale-orders?page=1`)
        }
    }, 500)

    return (
        <section id="app-saleOrders" className="st-def-mar-TB">
            <Container fluid className="st-container">
                <div className="app-saleOrders">
                    <div className="app-header-wrapper d-flex mb-2">
                        <p className="app-heading text-capitalize">Sale Orders</p>
                    </div>
                    <div className="app-content-container">
                        <div className="app-card">
                            <div className="app-card-content bg-white border st-border-light st-default-rounded-block mb-3">
                                <div className="acc_top-bar border-bottom st-border-light">
                                    <SaleOrdersTableTopBar
                                        column__saleOrderNumber={column__saleOrderNumber}
                                        column__orderDate={column__orderDate}
                                        column__customers={column__customers}
                                        column__subTotal={column__subTotal}
                                        column__promoDiscount={column__promoDiscount}
                                        column__shipping={column__shipping}
                                        column__total={column__total}
                                        column__fullFillmentStatus={column__fullFillmentStatus}
                                        column__paymentStatus={column__paymentStatus}
                                        column__paymentMethod={column__paymentMethod}

                                        setColumn__saleOrderNumber={setColumn__saleOrderNumber}
                                        setColumn__orderDate={setColumn__orderDate}
                                        setColumn__customers={setColumn__customers}
                                        setColumn__subTotal={setColumn__subTotal}
                                        setColumn__promoDiscount={setColumn__promoDiscount}
                                        setColumn__shipping={setColumn__shipping}
                                        setColumn__total={setColumn__total}
                                        setColumn__fullFillmentStatus={setColumn__fullFillmentStatus}
                                        setColumn__paymentStatus={setColumn__paymentStatus}
                                        setColumn__paymentMethod={setColumn__paymentMethod}
                                        history={props.history}
                                        handleSearchChange={handleSearchChange}
                                    />
                                </div>

                                <div className="st-listing-table saleOrders-table">
                                    <SaleOrdersTable
                                        allCheckboxSelected={allCheckboxSelected}
                                        handleSelectAllChange={ev => handleSelectAllChange(ev)}
                                        saleOrders={saleOrders}
                                        column__saleOrderNumber={column__saleOrderNumber}
                                        column__orderDate={column__orderDate}
                                        column__customers={column__customers}
                                        column__subTotal={column__subTotal}
                                        column__promoDiscount={column__promoDiscount}
                                        column__shipping={column__shipping}
                                        column__total={column__total}
                                        column__fullFillmentStatus={column__fullFillmentStatus}
                                        column__paymentStatus={column__paymentStatus}
                                        column__paymentMethod={column__paymentMethod}

                                        loadingCount={loadingCount}
                                        loading={loading}
                                        handleDelete={(ev, id) => handleDelete(ev, id)}

                                        orderStatusList={orderStatusList}
                                    />

                                </div>
                            </div>

                            <div className="pagination-container d-flex justify-content-end">
                                <Pagination
                                    searchQuery={searchQuery}
                                    routeName={"/my-sales/sale-orders"}
                                    paginationLinks={paginationLinks}
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </Container>
        </section>
    )
}

const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser,
        commonToken: state.auth.commonToken,
    };
}

// const dispatchActionsToProps = dispatch => {
//     return {
//         functionsData: (prop) => dispatch(functionsData(prop)),
//     }
// }

export default connect(getDataFromStore, null)(SaleOrders)